/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { FunctionComponent } from 'react';

import { DateTime } from '../../../core/utils';

/**
 * Duration displays a formatted duration string as a styled caption.
 * Converts seconds to a human-readable format (e.g., "1h 23m").
 * @param duration - Duration in seconds.
 * @param className - Optional CSS class for custom styling.
 */
const Duration: FunctionComponent<{ duration?: number; className?: string }> = ({
    duration,
    className: aClassName = '',
}) => {
    if (!duration) return null;
    const formattedDuration = DateTime.secondsToString(duration);
    const defaultClassName = 'primary-text-style muted-color text-light';
    return <span className={`uikit ${aClassName || defaultClassName}`}>{formattedDuration}</span>;
};

export default Duration;
